import React, { Component, createRef } from "react";
import moment from "moment/moment";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import { Card, Col, Container, Row } from "reactstrap";

import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addStockFillerInWards,
  assignGraderToFillerInWardsRepeats,
  getAssignCubesFillerToMachinOperators,
  getAssignGraderToFillerStocks,
  getFillerDashboard,
  getFillerInwardStock,
  getFillerPendingStock,
  getFillerRejectStock,
  getFillerStockList,
  getSummaryStock,
  updateAssignGraderToFillerInWards,
} from "api";
import { withTranslation } from "react-i18next";
import RaisedButton from "components/Common/RaisedButton";

class StockSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      summaryStock: [],
    };
  }

  async componentDidMount() {
    
    const summaryStock = await getSummaryStock();
    console.log(summaryStock)
    if (summaryStock && summaryStock.data) {
      this.setState({
        summaryStock:
          summaryStock.data.fillerStock.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  updatedAt: "",
                  fillerStatus: "P",
                  assignGraderToFillerStock: null,
                },
              ]
            : summaryStock.data.fillerStock,
      });
    }
  }


  render() {
    this.columns3 = [
      {
        dataField: "id",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row?.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "pieces",
        style: { width: "120px" },
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(
            x => x.ar
          ).length;
          ;
          {
            return tot == row?.dataEntryStock?.stockDataEntryInWards?.length ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.pieces}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.pieces}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "weight",
        style: { width: "130px" },
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards
            ?.filter(x => x.ar)
            .reduce((acc, item) => acc + item.weight, 0)
            .toFixed(2);
          {
            return tot == row.jangad.weight ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.weight}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.weight}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => {
          return (
            <Link
            to={{
              pathname: "/machine-operator-summary-show",
              query: {
                isEdit: 3,
                data: row,
              },
            }}
          >
            <button className="py-2 px-2 border-0 rounded me-2">
              <img src="images/dashboard-images/view.svg" />
            </button>
          </Link>
          );
        },
      },
    ];

    document.title = "stock summary";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Stock Summary")} />
 
            <div className="row px-3 ">
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    remote
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    // expandRow={expandRow3}
                    data={this.state.summaryStock}
                    columns={this.columns3}
                  />
                </div>
              </Card>
            </div>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(StockSummary);
